<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M4 7.5C4 6.67157 4.67157 6 5.5 6H9.17157C9.70201 6 10.2107 6.21071 10.5858 6.58579L12 8H18.5C19.3284 8 20 8.67157 20 9.5V17.5C20 18.3284 19.3284 19 18.5 19H5.5C4.67157 19 4 18.3284 4 17.5V7.5Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
</svg>
